
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cadastro",
      function () {
        return require("private-next-pages/cadastro.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cadastro"])
      });
    }
  